import { Stack, Image, ImageFit, Label, PrimaryButton, DefaultButton, FontIcon } from '@fluentui/react';
import React, { useContext, useEffect, useState } from 'react';
import styles from '../../styles/collectie.module.scss';
import { TProduct, TShoppingCart, TSize } from '../../constants/types';
import PulseLabel from '../pulseLabelComponent';
import { AlertButtonComponent } from '../alertButtonComponent';
import GlobalContext from '../../_contexts/GlobalContext';
import { generateProductUrl } from '../../helpers/General';
import { NavLink } from 'react-router-dom';
import ImageViewerSplashContext from '../../_contexts/ImageViewerContext';

export interface IProductListProps {
    product: TProduct;
    onBuyClick: Function;
    animationsEnabled: boolean;
    hideSwipe: boolean;
    SetSelectedProductForAlert?: Function;
    AlertCoachmarkVisible: boolean;
    shoppingkart: TShoppingCart;
}

const ProductListItem : React.FunctionComponent<IProductListProps> = (props : IProductListProps) => {
    const [selectedImageIndex, setSelectedImageIndex] = useState<number>(0);
    const [startSwipe, setStartSwipe] = useState<number>(-1);
    const [endSwipe, setEndSwipe] = useState<number>(-1);
    const [added, setAdded] = useState<boolean>(false);
    const [notAdded, setNotAdded] = useState<boolean>(false);
    const [shimmerStyle, setShimmerStyle] = useState<string>("");
    const [ammountInKart, setammountInKart] = useState<number>(0);
    const [shimmerEnabled, setShimmerEnabled] = useState<boolean>(true);
    const [pictureInfoVisible, setpictureInfoVisible] = useState<boolean>(false);
    const [mouseX, setmouseX] = useState<number>();
    const [mouseY, setmouseY] = useState<number>();
    const [product, setproduct] = useState<TProduct>(props.product);

    const { SetToastMessage, Strings, AnimationsEnabled, PRODUCT_TAGS } = useContext(GlobalContext);

    useEffect(() => {
        if (AnimationsEnabled && product.priceInUSD > 5) {
            const r = Math.floor(Math.random() * 4);
            setShimmerStyle(styles[`cardshimmer${r}`]);
        } else {
            setShimmerStyle("");
        }
    },[AnimationsEnabled]);

    useEffect(() => {
        let found = false;
        props.shoppingkart.items.forEach((item) => {
            if (item.product?.id === product.id) {
                setammountInKart(item.ammount);
                found=true;
            }
            if (item.set?.id === product.setID) {
                setammountInKart(product.available);
                found=true;
            }
        });
        if (found === false) {
            setammountInKart(0);
        }
    },[props]);

    useEffect(() => {
        setproduct(props.product);
    },[props.product]);

    function swipeEnd(e) {
        if (startSwipe != -1 && endSwipe != -1) {
            if ((endSwipe - startSwipe) > 20) {
                selectedImageIndex > 0 ? setSelectedImageIndex(this.state.selectedImageIdex-1) : setSelectedImageIndex(this.props.card.imageUrls.length -1);
            } else if ((startSwipe - endSwipe) > 20) {
                selectedImageIndex+1 < props.product.imageUrls.length ? setSelectedImageIndex(selectedImageIndex+1) : setSelectedImageIndex(0);
            }
            setStartSwipe(-1);
            setEndSwipe(-1);
        }
    }

    function tryAddToChart(card:TProduct) {
        let done = false;
        if (card.available > 0) {
            done = props.onBuyClick(card); 
        }
        if (done) {
            setAdded(true);
            setTimeout(() => {
                setAdded(false);
            }, 500);
        } else {
            SetToastMessage("Niet meer beschikbaar");
            setNotAdded(true);
            setTimeout(() => {
                setNotAdded(false);
            }, 500);
        }
    }

    function onMouseOver() {
        setShimmerEnabled(false);
        setTimeout(() => {
            setShimmerEnabled(false);
        }, 300);
    }

    function onMouseLeave() {
        setTimeout(() => {
            setShimmerEnabled(true);
        }, 300);
    }

    function onNavMouseMove(e) {
        setmouseX(e.clientX-110);
        setmouseY(e.clientY-50);
    }

    return (
        <Stack className={styles.card}>

            {product.tags && <div style={{display:pictureInfoVisible?"block":"none", top:mouseY, left:mouseX}} className={`${styles.imageClickForHighRez} ${pictureInfoVisible ? styles.fadeIn : ""}`}>Click voor hoge resolutie foto</div>}

            <Stack style={{height:"100%"}}>
                <Stack horizontal horizontalAlign='center' style={{marginTop:3,padding:2,fontFamily:"'Flexo-Demi', arial, sans-serif",color:"#F2F2F2",backgroundColor:"rgb(48, 167, 215)",borderRadius:5}}>
                    <NavLink to={generateProductUrl(product)} style={{textDecoration:"none",overflow:"hidden",color:"#F2F2F2"}}>
                        <Label title={product.title} style={{fontFamily:"'Flexo-Demi', arial, sans-serif",color:"#F2F2F2",backgroundColor:"rgb(48, 167, 215)",borderRadius:10, whiteSpace:"nowrap", cursor:"pointer",textOverflow:"ellipsis", display:"inline"}}>{product.title}</Label>
                    </NavLink>
                </Stack>
                <Stack horizontal>
                    <div className={`${styles.cardTitleContainer}`}>
                        <Stack horizontal horizontalAlign='space-between'>
                            <Stack horizontal horizontalAlign='start'>
                            </Stack>
                            <Stack horizontal horizontalAlign='end' className={styles.cardHeaderBanner}>
                                {product.available === 0 && <Image {...{imageFit: ImageFit.centerContain,
                                        className: styles.soldOut,
                                        src: process.env.PUBLIC_URL + `/assets/soldout.webp`,
                                        styles: props => ({ root: { margin: 0, marginTop:-15, zIndex: 1} }),
                                    }} alt="" />}
                            </Stack>
                        </Stack>
                    </div>
                </Stack>
                <NavLink to={generateProductUrl(product)} style={{textDecoration:"none",overflow:"visible",color:"#F2F2F2"}} onMouseMove={onNavMouseMove} onMouseOver={() => { setpictureInfoVisible(true); }} onMouseLeave={() => { setpictureInfoVisible(false); }}>
                    <Stack horizontal onMouseEnter={onMouseOver} onMouseLeave={onMouseLeave} verticalAlign='center' horizontalAlign='center' style={{overflow:"visible"}}>
                        <div style={{overflow:shimmerEnabled?"hidden":"visible"}} className={`${styles.cardshine} ${styles.cardCompImg}`}>
                            <Image {...{imageFit: ImageFit.centerContain,
                                        className: styles.cardCompImg,
                                        src: product.imageUrls[selectedImageIndex].replace(".jpeg",".webp").replace(".jpg",".webp"),
                                        onTouchStart: (e) => { setStartSwipe(e.targetTouches[0].clientX); },
                                        onTouchMove: (e) => { setEndSwipe(e.targetTouches[0].clientX); },
                                        onTouchEnd: swipeEnd,
                                        onError: ( e ) => { e.currentTarget.onerror = null; 
                                                            e.currentTarget.src=`${process.env.PUBLIC_URL}/assets/NoImgFound.webp`},
                                        styles: props => ({ root: { margin: 0, cursor: "pointer", backgroundColor: "transparent" } }),
                                    }} alt="" />
                            {shimmerEnabled && <div className={shimmerStyle}></div>}
                        </div>
                    </Stack>
                </NavLink>
                <Stack horizontalAlign='center' horizontal verticalAlign='center'>
                    <FontIcon aria-label="Vorige" className={styles.prevNextIcon} onClick={() => {selectedImageIndex > 0 ? setSelectedImageIndex(selectedImageIndex-1) : setSelectedImageIndex(product.imageUrls.length -1)}} iconName="ChevronLeft" />
                    {selectedImageIndex+1} / {product.imageUrls.length} 
                    <FontIcon aria-label="Volgende" className={styles.prevNextIcon} onClick={() => {selectedImageIndex+1 < product.imageUrls.length ? setSelectedImageIndex(selectedImageIndex+1) : setSelectedImageIndex(0)}} iconName="ChevronRight" />
                </Stack>
                {product.tags && <Stack className={styles.cardInfo} style={{height:"100%"}}>
                    <hr className={styles.cardInfohr} />
                    <Stack style={{height:"100%"}}>
                        {product.tags.map(tag => {
                            return <Stack horizontal horizontalAlign='space-between'>
                                        <Stack horizontal horizontalAlign='end'>
                                            <Label className={styles.generalLabel}>&nbsp;{tag.key}</Label>
                                        </Stack>
                                        <Stack horizontal horizontalAlign='end'>
                                            {tag.value === '1' || tag.value === '0' ? <Label className={styles.infoLabel}>{tag.value  === '1' ? "Ja" : "Nee"}</Label>
                                                                                    : <Label className={styles.infoLabel}>{tag.value ? tag.value : "Onbekend"}</Label>}
                                        </Stack>
                                </Stack>
                        })}
                        <Stack verticalAlign='end' style={{height:"100%", marginTop:-5}}>
                            <hr className={styles.cardInfohr} />
                            <Stack horizontal horizontalAlign='space-between' style={{marginBottom:5, marginTop: 2}}>
                                <Stack verticalAlign='center'>
                                    {product.priceInEUR > 0 ?
                                        <PulseLabel style={{fontSize:"normal!important",fontWeight:"bold"}} text={`€ ${product.priceInEUR.toFixed(2)}`} />
                                        : <Label>€ ---.--</Label>}
                                </Stack>
                                <Stack horizontal horizontalAlign='end' className={styles.butButtonDiv}>
                                    {product.priceInEUR != 0 && product.available - ammountInKart > 0 ?
                                        <FontIcon style={{width:90, maxHeight:"90%", verticalAlign:"middle", fontSize:25, backgroundColor:"#30a7d7"}} 
                                                aria-label={Strings?.AddToCart} onClick={() => {tryAddToChart(product);}} 
                                                className={`${styles.buyButton} ${added ? styles.added : notAdded ? styles.notAdded : ""}`} 
                                                iconName={added ? "ShoppingCartSolid" : "ShoppingCart"} />
                                        :
                                        <AlertButtonComponent Visible={props.AlertCoachmarkVisible} OnClick={() => { props.SetSelectedProductForAlert(product); }} />
                                    }
                                </Stack>
                            </Stack>
                        </Stack>
                    </Stack>
                </Stack>}
            </Stack>
        </Stack> 
    );
}

export default ProductListItem;